import { useMemo } from "react";
import { SWRConfiguration, SWRResponse } from "swr";

import { GetSpeciesById, GetSpeciesByIdResponse } from "../../api/dtos/dtos";
import useGet from "../api/useGet";


const getData = (response?: SWRResponse<GetSpeciesByIdResponse, GetSpeciesByIdResponse>) => response?.data?.species;
const getError = (response?: SWRResponse<GetSpeciesByIdResponse, GetSpeciesByIdResponse>) => (response?.error ?? response?.data)?.responseStatus;
const getAdditionalState = (_?: SWRResponse<GetSpeciesByIdResponse, GetSpeciesByIdResponse>) => ({});

const useGetSpeciesById = (query?: Partial<GetSpeciesById>, configuration?: SWRConfiguration) => {
    const request = useMemo(() => {
        if (!query) {
            return undefined;
        }

        return () => {
            return new GetSpeciesById(query);
        }
    }, [query]);

    return useGet(request, { getData, getError, getAdditionalState }, configuration);
}

export default useGetSpeciesById;